import { atom } from "recoil";
import { PriceConfiguratorData } from "src/types/priceConfigurator";

export const priceConfiguratorsRepositoryState = atom<PriceConfiguratorData[]>({
  key: "priceConfiguratorsRepositoryState",
  default: [],
});
